import Icon from '../components/Icon'

Icon.register({
  'i-cursor': {
    width: 256,
    height: 512,
    paths: [
      {
        d: 'M256 52c0 6.6-5.4 12-12 12-27.9-0.1-84 3.2-84 48.1v111.8h36c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-36v112c0 44.9 57.9 48.6 83.9 48.2 6.7-0.1 12.1 5.3 12.1 12v39.6c0 6.6-5.3 12-11.9 12-35.1 0.2-78.4-0.6-116.1-37.8-38.5 37.9-83.6 38.3-116.2 37.9-6.6-0.1-11.8-5.4-11.8-12v-40c0-6.6 5.4-12 12-12 27.9 0.1 84-3 84-48v-112h-36c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h36v-111.8c0-44.9-57.9-48.7-83.9-48.4-6.7 0.1-12.1-5.3-12.1-12v-39.6c0-6.6 5.3-12 11.9-12 35.1-0.2 78.4 0.6 116.1 37.8 38.5-37.9 83.6-38.3 116.2-37.9 6.6 0.1 11.8 5.4 11.8 12v40z'
      }
    ]
  }
})
